import { post, get } from '../../../../services/request';

//-------------------Rad leadership - start----------------//
// Get all Provider Leadership
export const getAllRadLeadership = () => {
    return get('RADReport/GetAllRADReport');
};
 
//bulk update save
export const saveRadLeadershipBulkUpdate = data => {
    return post('RadReport/SaveRadReports', data);
};
 
// Check if user can edit Provider Leadership (check if someone else is editing)
export const checkRadLeadershipEditAccess = (userId) => {
    return post(`RadReport/SaveRadLeadershipBulkUpdateUser?UserId=${userId}`, {});
}
 
// Delete Provider Leadership bulk update user session
export const deleteRadLeadershipBulkUpdateUser = (userId) => {
    return post(`RadReport/DeleteRadLeadershipBulkUpdateUser?UserId=${userId}`, {});
};
//-------------------Rad Leadership - end----------------//